const n = ":host{display:inline-flex;align-items:center;justify-content:center}.sl-spinner{position:relative;display:inline-flex;align-items:center;justify-content:center}.sl-spinner__track,.sl-spinner__progress{position:absolute;border-radius:var(--sl-radius-full)}.sl-spinner__track{width:100%;height:100%;border:var(--sl-spinner-border-width) solid var(--sl-spinner-track-color,var(--sl-border-color))}.sl-spinner__progress{width:100%;height:100%;border:var(--sl-spinner-border-width) solid transparent;border-top-color:var(--sl-spinner-color,hsl(var(--sl-hsl-primary)));border-right-color:var(--sl-spinner-color,hsl(var(--sl-hsl-primary)));border-bottom-color:var(--sl-spinner-color,hsl(var(--sl-hsl-primary)));animation:sl-spinner-rotate var(--sl-spinner-duration,800ms) linear infinite}.sl-spinner__sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.sl-spinner--sm{--sl-spinner-size:1rem;--sl-spinner-border-width:2px;--sl-spinner-duration:600ms}.sl-spinner--md{--sl-spinner-size:1.5rem;--sl-spinner-border-width:3px;--sl-spinner-duration:800ms}.sl-spinner--lg{--sl-spinner-size:2.5rem;--sl-spinner-border-width:4px;--sl-spinner-duration:1000ms}.sl-spinner--xl{--sl-spinner-size:4rem;--sl-spinner-border-width:5px;--sl-spinner-duration:1200ms}.sl-spinner{width:var(--sl-spinner-size);height:var(--sl-spinner-size)}@keyframes sl-spinner-rotate{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}";
class i extends HTMLElement {
  static get observedAttributes() {
    return ["size", "label"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  attributeChangedCallback(s, e, r) {
    e !== r && this._render();
  }
  get size() {
    return this.getAttribute("size") || "md";
  }
  set size(s) {
    this.setAttribute("size", s);
  }
  get label() {
    return this.getAttribute("label") || "Loading";
  }
  set label(s) {
    this.setAttribute("label", s);
  }
  _render() {
    const e = ["sl-spinner", `sl-spinner--${this.size}`];
    this._shadow.innerHTML = `
      <style>${n}</style>
      <div class="${e.join(" ")}" role="status" aria-label="${this.label}">
        <div class="sl-spinner__track"></div>
        <div class="sl-spinner__progress"></div>
        <span class="sl-spinner__sr-only">${this.label}</span>
      </div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-spinner") && customElements.define("sl-spinner", i);
export {
  i as SlSpinnerElement
};
//# sourceMappingURL=sl-spinner.js.map
